import React from "react";
import { ChevronRight, Plus } from "lucide-react"; // or use Ant's PlusOutlined if needed
import NavigationButton from "./navigation_button";
import MarketPlaceIcon from "./MarketplaceIcon";

interface Link {
  platform: string;
  url: string;
  icon: React.ReactNode;
}

interface MobileSocialLinksListProps {
  links: Link[];
  title?: string;
  showDrawer: (isNew: boolean, link?: Link) => void;
}

const MobileSocialLinksList: React.FC<MobileSocialLinksListProps> = ({ links, title = "Your Social Media Presence", showDrawer }) => {
  return (
    <div className="block md:hidden flex flex-col gap-y-4 items-start">
      <div className="common-title text-[#1d2939] text-base pb-[14px]">{title}</div>

      {links.map((link, index) => (
        link.platform && (
          <div className="border border-[#F2F4F7] p-[14px] rounded-[6px] w-full" key={index}>
            <div className="flex gap-x-[10px] items-center w-full">
              {/* Left Icon */}
              <div className="flex items-center justify-center p-2 bg-[#f2f4f7] rounded-[40px]">
                {link.icon??<MarketPlaceIcon />}
              </div>

              {/* Text and Right Icon Section */}
              <div className="flex flex-col gap-y-2 w-full">
                {/* Platform and Chevron */}
                <div className="flex items-center justify-between w-full">
                  <p className="text-[#344054] text-sm font-medium font-['Inter'] leading-tight m-0">
                    {link.platform}
                  </p>
                  <div className="shrink-0 cursor-pointer" onClick={() => showDrawer(false, link)}>
                    <ChevronRight />
                  </div>
                </div>

                {/* URL */}
                <p className="text-[#175cd3] text-[13px] font-normal font-['Inter'] leading-[19px] m-0">
                  {link.url}
                </p>
              </div>
            </div>
          </div>
        )
      ))}

      {/* Add New Button */}
      <NavigationButton
        type="text"
        icon={<Plus />}
        onClick={() => showDrawer(true)}
        label="Add New"
      />
    </div>
  );
};

export default MobileSocialLinksList;
